import RemindAPI from 'lib/RemindAPI';
import { stripTypename } from '../utils';
import { ActionResponse, DefaultActionError, DEFAULT_ACTION_ERROR } from 'translations/types';
import { TranslatedMessageInput } from 'globalTypes';

// translatedMessage Mutation Imports
import TRANSLATED_MESSAGE_QUERY from '../queries/TranslatedMessageQuery.gql';
import {
  TranslatedMessage,
  TranslatedMessageVariables,
} from 'translations/queries/__generated__/TranslatedMessage';

// translatedMessage
export type TranslatedMessagePayload = {
  languageCode: string;
  translatedText: string;
};

export async function translatedMessage(
  input: TranslatedMessageInput
): Promise<ActionResponse<TranslatedMessagePayload, DefaultActionError>> {
  const { translations: resp } = await RemindAPI.execute<
    TranslatedMessage,
    TranslatedMessageVariables
  >({
    query: TRANSLATED_MESSAGE_QUERY,
    variables: { input },
  });
  const data = resp?.translatedMessage?.data;
  const error = resp?.translatedMessage?.error;

  if (error || !data) {
    return {
      success: false,
      ...(error ? stripTypename(error) : DEFAULT_ACTION_ERROR),
    };
  } else {
    return { success: true, ...stripTypename(data) };
  }
}
